import { render, staticRenderFns } from "./RecallCard.vue?vue&type=template&id=4e26601a&scoped=true&"
import script from "./RecallCard.vue?vue&type=script&lang=js&"
export * from "./RecallCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e26601a",
  null
  
)

export default component.exports